export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Hours'
    },
    unique: [],
    sort: 'time',
    lang: {
        name: 'Total Hours',
        category: ['User', 'Plays'],
        description: 'Number of hours played across all-time or a specific time period.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['total.hours']
}